import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import styled from 'styled-components';
import { GREE_1 } from '../utils/colors';
import { ROUTES } from '../constants/PathRoutes';

const { Title } = Typography;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
`;

const StyledCard = styled(Card)`
  width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const StyledTitle = styled(Title)`
  text-align: center;
  color: ${GREE_1};
  margin-bottom: 24px !important;
`;

export default function AdminLogin() {
    const [loading, setLoading] = useState(false);
    const { login } = useAdminAuth();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            await login(values.email, values.password);
            message.success('Login administrativo realizado com sucesso!');
            navigate(ROUTES.ADMIN_DASHBOARD);
        } catch (error) {
            message.error(error.response?.data?.detail || 'Erro ao fazer login. Verifique suas credenciais.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <StyledCard>
                <StyledTitle level={2}>Login - Admin</StyledTitle>
                <Form
                    name="admin_login"
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Por favor, insira seu email!' },
                            { type: 'email', message: 'Email inválido!' }
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="admin@email.com"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Senha"
                        name="password"
                        rules={[{ required: true, message: 'Por favor, insira sua senha!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="Senha"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            size="large"
                        >
                            Entrar
                        </Button>
                    </Form.Item>
                </Form>
            </StyledCard>
        </Container>
    );
}